import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, LaptopIcon, ArrowRightIcon } from 'lucide-react';
import { Badge } from '../ui/Shared';
import { PlanSelector } from '../ui/PlanSelector';
export const PricingSection = () => {
  return <>
      {/* Launch offer banner */}
      <section className="py-12 px-5 bg-bg-alt text-center" data-id="element-180">
        <div className="max-w-[860px] mx-auto" data-id="element-181">
          <p className="text-xs tracking-[0.1em] uppercase text-cyan mb-3 font-semibold" data-id="element-182">
            Oferta de lanzamiento
          </p>
          <h2 className="text-[clamp(26px,4vw,36px)] font-extrabold leading-[1.2]" data-id="element-183">
            Precio especial por tiempo limitado
          </h2>
          <p className="text-xs text-rojo font-semibold mt-2" data-id="element-184">
            Cuando termine, no vuelve a bajar
          </p>

          <div className="max-w-[400px] mx-auto mt-6" data-id="element-185">
            <div className="flex justify-between text-xs text-gris-claro mb-1.5" data-id="element-186">
              <span data-id="element-187">Cupos restantes</span>
              <span className="text-cyan font-semibold" data-id="element-188">68% tomados</span>
            </div>
            <div className="bg-[#222] rounded-full h-2 overflow-hidden" data-id="element-189">
              <div className="bg-cyan h-full rounded-full w-[68%]" data-id="element-190"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Selector */}
      <section className="py-16 md:py-20 px-5" id="ofertas" data-id="element-191">
        <div className="max-w-[860px] mx-auto" data-id="element-192">
          <div className="text-center mb-8 md:mb-10" data-id="element-193">
            <p className="text-xs tracking-[0.1em] uppercase text-cyan mb-3 font-semibold" data-id="element-194">
              Elegí tu plan
            </p>
            <h2 className="text-[clamp(26px,4vw,36px)] font-extrabold leading-[1.2] mb-3" data-id="element-195">
              KIT ITALIANO PRO™
            </h2>
            <p className="text-[15px] md:text-[16px] text-[#aaa] max-w-[560px] mx-auto" data-id="element-196">
              Ambas opciones incluyen los 6 módulos y los 6 bonos. Tocá para
              elegir.
            </p>
          </div>

          <PlanSelector variant="full" data-id="element-197" />
        </div>
      </section>

      {/* Pro Features */}
      <section className="py-20 px-5 bg-bg-alt pt-[40px] pb-[40px]" data-id="element-198">
        <div className="max-w-[860px] mx-auto" data-id="element-199">
          <div className="text-center mb-4" data-id="element-200">
            <Badge color="cyan" data-id="element-201">Solo en el Pack PRO</Badge>
          </div>
          <div className="text-center mb-10" data-id="element-202">
            <h2 className="text-[clamp(26px,4vw,36px)] font-extrabold leading-[1.2] mb-3" data-id="element-203">
              ¿Qué agregan los Tomos PRO™?
            </h2>
            <p className="text-[16px] text-[#aaa] max-w-[580px] mx-auto" data-id="element-204">
              Para profesores que quieren ir un paso más allá — el mercado
              corporativo y el negocio digital
            </p>
          </div>

          <div className="flex flex-col gap-2.5" data-id="element-205">
            {[{
            num: 'I',
            label: 'TOMO PRO I',
            pages: '60 págs.',
            title: 'Italiano Corporativo: el mercado que pocos docentes trabajan',
            desc: 'Cómo entrar al segmento de empresas con capitales italianos en Argentina — Stellantis, Ferrero, Pirelli, Lavazza. Vocabulario técnico por sector, propuesta in-company, tarifas en dólares y cómo cerrar el primer cliente empresa. Con una sola clase corporativa recuperás la diferencia de precio entre las dos ofertas.',
            highlight: 'Tarifas en dólares',
            icon: BriefcaseIcon
          }, {
            num: 'II',
            label: 'TOMO PRO II',
            pages: '60 págs.',
            title: 'De Profesor a Negocio Digital: ingresos más allá de las clases',
            desc: 'El sistema completo para crear y vender productos digitales de italiano, armar un programa online, cobrar por Mercado Pago o en dólares vía Gumroad y construir una fuente de ingresos que no dependa de cuántas horas podés trabajar. Hoja de ruta de 90 días incluida.',
            highlight: 'Hoja de ruta 90 días',
            icon: LaptopIcon
          }].map((t, i) => {
            const Icon = t.icon;
            return <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.4,
              delay: i * 0.1,
              ease: 'easeOut'
            }} whileHover={{
              x: 4
            }} className="group relative bg-gris-oscuro border border-cyan/20 rounded-xl overflow-hidden hover:border-cyan/50 hover:shadow-[0_0_24px_rgba(0,229,255,0.08)] transition-all duration-300" data-id="element-206">
                  <div className="flex items-stretch gap-0" data-id="element-207">
                    <div className="relative shrink-0 w-[72px] sm:w-[96px] flex items-center justify-center bg-gradient-to-br from-cyan/15 to-cyan/[0.03] border-r border-cyan/20" data-id="element-208">
                      <div className="absolute inset-0 bg-cyan/5 group-hover:bg-cyan/10 transition-colors" data-id="element-209"></div>
                      <Icon size={30} strokeWidth={1.8} className="text-cyan relative z-10 transition-transform duration-300 group-hover:scale-110" aria-hidden="true" data-id="element-210" />
                      <span className="absolute top-1.5 left-1.5 text-[10px] font-extrabold tracking-wider text-cyan/70" data-id="element-211">
                        {t.num}
                      </span>
                    </div>

                    <div className="flex-1 min-w-0 p-3.5 sm:p-5" data-id="element-212">
                      <div className="flex items-start justify-between gap-2 mb-1.5 flex-wrap" data-id="element-213">
                        <p className="text-[10px] font-bold text-cyan tracking-widest uppercase" data-id="element-214">
                          {t.label} · {t.pages}
                        </p>
                        <span className="shrink-0 inline-flex items-center gap-1 text-[10px] font-bold bg-cyan/10 text-cyan px-2 py-0.5 rounded-full border border-cyan/25 whitespace-nowrap" data-id="element-215">
                          ⭐ {t.highlight}
                        </span>
                      </div>
                      <p className="text-[14px] sm:text-[15px] font-bold text-blanco leading-snug mb-1.5" data-id="element-216">
                        {t.title}
                      </p>
                      <p className="text-[12px] sm:text-[12.5px] text-[#aaa] leading-relaxed line-clamp-3 sm:line-clamp-none" data-id="element-217">
                        {t.desc}
                      </p>
                    </div>

                    <div className="hidden md:flex shrink-0 items-center pr-4" data-id="element-218">
                      <ArrowRightIcon size={16} className="text-gris-claro/40 group-hover:text-cyan group-hover:translate-x-1 transition-all duration-300" data-id="element-219" />
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-20 px-5" data-id="element-220">
        <div className="max-w-[860px] mx-auto" data-id="element-221">
          <div className="bg-verde/5 border border-verde/20 rounded-2xl p-10 text-center max-w-[600px] mx-auto" data-id="element-222">
            <div className="text-[64px] font-extrabold text-verde leading-none mb-1" data-id="element-223">
              7
            </div>
            <div className="text-[18px] font-bold text-verde mb-3.5" data-id="element-224">
              DÍAS DE GARANTÍA TOTAL
            </div>
            <p className="text-[15px] text-[#aaa] leading-relaxed max-w-[440px] mx-auto mb-3" data-id="element-225">
              Abrís los módulos, probás los bonos con tu próximo alumno. Si no
              es lo que esperabas: sin preguntas, sin formularios, sin drama. Te
              devolvemos el 100% del dinero.
            </p>
            <p className="text-[12px] text-gris-claro" data-id="element-226">
              (Tasa de devoluciones &lt; 1%)
            </p>
          </div>
        </div>
      </section>
    </>;
};